export const Types = {
  SAVE_LOADINGS: 'SAVE_LOADINGS',
  SAVE_OPEN_HIDE_SIDERBAR: 'SAVE_OPEN_HIDE_SIDERBAR',
  SAVE_LIST_CONFIG: 'SAVE_LIST_CONFIG',
}
